export const config = {
  "apiBaseUrl": "https://api.fandmintel.com/v1",
  "userPoolId": "eu-west-2_8JC5ioTTo",
  "clientId": "2um4d4cl089cq3f57083lvjn31",
  "region": "eu-west-2",
  "cognitoLoginUrl": "https://fm.auth.eu-west-2.amazoncognito.com/login",
  "cognitoLogoutUrl": "https://fm.auth.eu-west-2.amazoncognito.com/logout",
  "cognitoUserInfoUrl": "https://fm.auth.eu-west-2.amazoncognito.com/oauth2/userInfo",
  "cognitoTokenUrl": "https://fm.auth.eu-west-2.amazoncognito.com/oauth2/token",
  "googleMapsApiKey": "AIzaSyAkYKyeN4ln9KdDFWBzCwcITkXUBCzbaNs",
  "bootstrap": true
};
